import { BaseApiResponseType } from 'src/models/BaseApi';
import { DonationSetupPresetAmountListResponseType } from 'src/models/DonationPage/PresetAmounts';

export enum DonationPageTabsEnum {
  FIRST = 'DonationPage',
  SECOND = 'DonationPageCheckout',
  THIRD = 'DonationPageOptions',
}

export type DonationPageSectionsType = {
  disabled: boolean;
  title: string;
  name: DonationPageTabsEnum;
  progress: number;
  errorCount: number;
}[];

export type TrayIoBloomerangFieldValue = {
  Id: number;
  Name: string;
  FieldTypeID: number;
};

export type TrayIoLittleGreenLightFieldValue = {
  Id: number;
  Name: string;
  FieldTypeID: number;
};

export type DonationPageMainSectionRequestType = {
  nextSectionName: DonationPageTabsEnum | null;
  viewModel: {
    Progress: number;
    IsDirty: boolean; // won't be saved if false
    PermanentUrl: string;
    CampaignName: string;
    ShortDescription: string;
    ShowCampaignHeadline: boolean;
    // IsStartCampaignAutomatically: boolean;
    // DesiredStartDate: string; // '06/11/2021'
    // DesiredStartTime: string; // '17:39:00'
    Medias: {
      Items: [
        {
          ID: null | number; // null if new image
          MediaType: number;
          ImageUri: string | null; // it must end with '?'
        }
      ];
    };
    // ContributionButtonTerminology: {
    //   SelectedTerminology: {
    //     ID: number | null;
    //     Text: string; // any text if id is set
    //     IsDefault: boolean;
    //   };
    // };
    UseContributionAmountPresets: boolean;
    ContributionAmountPresets: DonationSetupPresetAmountListResponseType['Items'] | null;
    IsContributionPresetsSortDesc: boolean;
    // PaymentMethods: {
    //   Value: number;
    //   IsSelected: boolean;
    // }[];
    // CurrencyTypeID: number;
    // Check:
    //   | {
    //       CheckPayableTo: string;
    //       CheckName: string;
    //       CheckAttentionTo: string | null;
    //       CheckAddressLine1: string;
    //       CheckAddressLine2: string | null;
    //       CheckAddressLine3: string | null;
    //       CheckCity: string;
    //       RegionID: number;
    //       CountryID: string;
    //       CheckZipCode: string;
    //     }
    //   | undefined;
    // IsAddressRequired: boolean;
    // IsPhoneNumberRequired: boolean;
    // EmailSubject: string | null;
    // EmailTemplate: string | null;
    // TextToGiveViewModel: {
    //   IsTextToGiveEnabled: boolean;
    //   TextToGiveKeyword: string | null;
    // };
    FriendlyUrl: string | null;
    // DefaultPricingViewModel: {
    //   DefaultPricingServiceFeeChargingTypeID: number | null;
    //   PromoCodeFeeChargingTypeCode: number | null;
    //   ConvenienceFeeAmount: unknown;
    //   IsConvenienceFeeEnabled: boolean;
    //   PricingTypeCode: number;
    //   ProcessingFeesChargedToSupporter: null | boolean;
    // };
    CauseTerminology: {
      SelectedTerminology: {
        TerminologyType: number;
        ID: number | null;
        Singular: string;
        Plural: string;
        Article: 'A' | 'An';
        IsCampaignSpecific: boolean;
      };
    };
    UseCauses: boolean;
    DonationPageDisplayingConfigurationModel: {
      IsBannerEnabled: boolean;
      IsFundImageEnabled: boolean;
      IsPresetDonationDescriptionEnabled: boolean;
      IsPresetDonationImageEnabled: boolean;
      IsPresetDonationTitleEnabled: boolean;
      // ShowDefaultPricingCard: boolean; // used for saving pricing settings
    };
  };
};

export type DonationPageCheckoutSectionRequestType = {
  nextSectionName: DonationPageTabsEnum | null;
  viewModel: {
    Progress: number;
    IsDirty: boolean; // won't be saved if false
    PermanentUrl: string;
    // Currencies: { ID: number; Name: string; Symbol: string; IsApplePayAndGooglePayAvailable: boolean }[];
    PaymentMethods: {
      Value: number;
      IsSelected: boolean;
    }[];
    CurrencyTypeID: number;
    Check:
      | {
          CheckPayableTo: string;
          CheckName: string;
          CheckAttentionTo: string | null;
          CheckAddressLine1: string;
          CheckAddressLine2: string | null;
          CheckAddressLine3: string | null;
          CheckCity: string;
          RegionID: number;
          CountryID: string;
          CheckZipCode: string;
        }
      | undefined;
    // Countries: {
    //   Disabled: boolean;
    //   Group: unknown;
    //   Selected: boolean;
    //   Text: string;
    //   Value: string;
    // }[];
    // UsRegions: {
    //   Abbreviation: string;
    //   Country: string;
    //   CountryID: unknown;
    //   DisplayName: string;
    //   ID: number;
    //   Name: string;
    // }[];
    // CanadaRegions: {
    //   Abbreviation: string;
    //   Country: string;
    //   CountryID: null;
    //   DisplayName: string;
    //   ID: number;
    //   Name: string;
    // }[];
    EmailSubject: string | null;
    EmailTemplate: string | null;
    AllowDonationDedication: boolean;
    UseCustomMinMaxContributionAmount: boolean;
    MinimumContributionAmount: number | null;
    MaximumContributionAmount: number | null;
    EnableMarketingEmailsOption: boolean;
    EnableMarketingEmailsOptionLabel: string | null;
    TextToGiveViewModel: {
      IsTextToGiveEnabled: boolean;
      TextToGiveKeyword: null | string;
      IsInternationalTextToGiveEnabled: boolean;
    };
    IsAddressRequired: boolean;
    IsPhoneNumberRequired: boolean;
    CustomFields: {
      BasicFields: [];
      CustomFields: {
        ID: number | null;
        Name: string;
        Collect: boolean;
        IsRequired: boolean;
        Sequence: number;
        CustomFieldTypeID: number;
        Readonly: boolean;
        HasOtherOption: boolean;
        Options: {
          ID: number | null;
          Name: string;
          Sequence: number;
        }[];
      }[];
    };
    DefaultPricingViewModel: {
      DefaultPricingServiceFeeChargingTypeID: number | null;
      DefaultPricingProcessingFeeChargingTypeID: number | null;
      PromoCodeFeeChargingTypeCode: number | null;
      ConvenienceFeeAmount: unknown;
      IsConvenienceFeeEnabled: boolean;
      PricingTypeCode: number;
      ProcessingFeesChargedToSupporter: null | boolean;
      ShowDefaultPricingCard: boolean; // used for saving pricing settings
      ConvenienceFeeAmountType: 1 | 2 | null;
    };
    PlusSubscriptionPricingViewModel: {
      ShowPlusSubscriptionPricingCard: boolean;
      ProcessingFeesChargedToSupporter: boolean;
      DefaultPricingServiceFeeChargingTypeID: number;
      DefaultPricingProcessingFeeChargingTypeID: number | null;
      IsConvenienceFeeEnabled: boolean;
      ConvenienceFeeAmount: number;
      ConvenienceFeeAmountType: 1 | 2 | null;
    };
    // HidePaymentMethods: boolean;
    // ShowAdditionalAmount: boolean;
    // CanHaveAdditionalAmount: boolean;
    // AreFixedContributionsAllowed: boolean;
    // AreFixedContributionsAllowedVisible: boolean;
    // IsPledge: boolean;
    // IsDonationWithoutItemsHeadlineAndButtonVisible: boolean;
    // ShowAreCompleteAnonymousContributions: boolean;
    // AreCompleteAnonymousContributionsDisabled: boolean;
    // ShowSpecialInstructions: boolean;
    // IsSpecialInstructionsVisible: boolean;
    // IsContributionPresetsSortDesc: boolean;
    // DonationWithoutItemsHeadLineText: string;
    // DonateWithoutItemsButtonText: string;
    // ContributionBankStatement: string;
    // PricingViewModel: {
    //   ShowOrganizerPromoCode: boolean;
    //   HaveOrganizerPromoCode: boolean;
    //   OrganizerPromoCode: string | null;
    //   OrganizerPromoCodeString: string | null;
    // };
    // UkGiftAidShown: boolean;
    // IsUkGiftAidEnabled: boolean;
    // GiftAidStatement: string;
    // GiftAidAgreement: string;
    // Notice: string;
    // IsSupporterNoticeAcknowledgmentRequired: boolean;
    // ContributionNotificationRecipients: { Email: string }[];
    // ContactOrganizerEmailRecipients: { Email: string }[];
    // TerminologiesViewModel: {
    //   ShowContributionTerminology: boolean;
    //   SupporterTerminologyModel: {
    //     SelectedTerminology: {
    //       /**
    //        * if IsCampaignSpecific set 'article, singular, plural' correct
    //        * otherwise set ID and any non empty 'article, singular, plural'
    //        */
    //       ID: number | null;
    //       Article: 'A' | 'An';
    //       Singular: string;
    //       Plural: string;
    //       IsCampaignSpecific: boolean;
    //       TerminologyType: number;
    //     };
    //   };
    //   ContributionTerminologyModel: {
    //     SelectedTerminology: {
    //       ID: number | null;
    //       Article: 'A' | 'An';
    //       Singular: string;
    //       Plural: string;
    //       Verb: string;
    //       IsCampaignSpecific: boolean;
    //       TerminologyType: number;
    //     };
    //   };
    // };
  };
};

export type DonationPageOptionSectionRequestType = {
  nextSectionName: DonationPageTabsEnum | null;
  viewModel: {
    // ?hardcode?
    CampaignTabTitle: {
      Header: 'Donation Page tab';
      ValidatationAttribute: 'CampaignTabTitle';
      FundraisingActivityType: null;
      Title: 'Donation Page';
    };
    TimezoneID: number;
    TerminologiesViewModel: {
      ShowContributionTerminology: boolean;
      SupporterTerminologyModel: {
        SelectedTerminology: {
          /**
           * if IsCampaignSpecific set 'article, singular, plural' correct
           * otherwise set ID and any non empty 'article, singular, plural'
           */
          ID: number | null;
          Article: 'A' | 'An';
          Singular: string;
          Plural: string;
          IsCampaignSpecific: boolean;
          TerminologyType: number;
        };
      };
      ContributionTerminologyModel: {
        SelectedTerminology: {
          ID: number | null;
          Article: 'A' | 'An';
          Singular: string;
          Plural: string;
          Verb: string;
          IsCampaignSpecific: boolean;
          TerminologyType: number;
        };
      };
    };
    // end ?hardcode?
    PermanentUrl: string;
    IsDirty: boolean;
    Progress: number;
    HaveFundCode: boolean;
    FundCode: string | null;
    PricingViewModel: {
      ShowOrganizerPromoCode: boolean;
      HaveOrganizerPromoCode: boolean;
      OrganizerPromoCode: string | null;
      PermanentUrl: string;
    };
    IsUkGiftAidEnabled: boolean;
    GiftAidStatement: string | null;
    GiftAidAgreement: string | null;
    ContributionBankStatement: string | null;
    ShowAdditionalAmount: boolean;
    AreFixedContributionsAllowed: boolean;
    DonationWithoutItemsHeadLineText: string | null;
    DonateWithoutItemsButtonText: string | null;
    AreCompleteAnonymousContributionsDisabled: boolean;
    AllowDonationDedication: boolean;
    IsSpecialInstructionsVisible: boolean;
    UseCustomMinMaxContributionAmount: boolean;
    MinimumContributionAmount: number | null;
    MaximumContributionAmount: number | null;
    EnableMarketingEmailsOption: boolean;
    EnableMarketingEmailsOptionLabel: string | null;
    Notice: string | null;
    IsSupporterNoticeAcknowledgmentRequired: boolean;
    ContributionNotificationRecipients: { Email: string }[];
    ContactOrganizerEmailRecipients: { Email: string }[];
    AreNotificationsAboutNewDonorsAndDonationsEnabled: boolean;
    AllowRecurringDonations: boolean;
    DefaultRecurrencePeriodID: number;
    AllowDonorsChooseRecurringDonationFrequency: boolean;
    IsRecurringDonationUpsellEnabled: boolean;
    UpsellPercentage: number;
    UpsellTitle: string | null;
    UpsellDescription: string | null;
    EnableAnonymousDonation: boolean;
    EnableHideEmail: boolean;
    IntegrationsOptionsSubsectionViewModel: {
      BloomerangFields: {
        CampaignFieldValueID: number | null;
        FundFieldValueID: number | null;
        AppealFieldValueID: number | null;
      };
      LittleGreenLightFields: {
        CampaignFieldValueID: number | null;
        FundFieldValueID: number | null;
        AppealFieldValueID: number | null;
        EventFieldValueID: number | null;
      };
      OrganizationId: number | null;
    } | null;
  };
};

export type DonationPageResponseType =
  | DonationPageFirstFormResponseType
  | DonationPageThirdFormResponseType
  | DonationPageSecondFormResponseType;

export type GlobalResponseType = {
  BenefitingUrl: string; // replace #17871
  CampaignID: number;
  CampaignSetupChangedGroupName: string | null;
  ID: string;
  NeedCreatePaymentProvideConfiguration: boolean;
  NeedRedirectToOrgSetup: boolean;
  NeedToCompleteAccount: boolean;
  NeedToSetupPartnerFunding: boolean;
  IsBenefitingOrganizationFrozen: boolean;
  CanAccessOrganizationVerifyAccountPage: boolean;
  Timeline: {
    IsVisible: boolean;
    Sections: {
      ErrorCount: number;
      IsActive: boolean;
      IsDisabled: boolean;
      IsValid: boolean;
      Progress: number;
      SectionName: DonationPageTabsEnum;
      SectionTitle: string;
    }[];
  };
  CanSubmit: boolean;
  EditMode: number;
  CampaignStatusID: number;
  DisplayingStatusCode: number;
  CurrentSection: {
    CampaignName: string;
    FundraisingActivityTypeCodes: number[];
    TerminologiesViewModel: {
      SupporterTerminologyModel: {
        DefaultTerminologies: {
          ID: number;
          Plural: string;
          Singular: string;
        }[];
        SelectedTerminology: {
          IsCampaignSpecific: boolean;
          ID: number;
          Plural: string;
          Singular: string;
          Article: 'A' | 'An';
        };
      };
      ContributionTerminologyModel: {
        DefaultTerminologies: {
          ID: number;
          Plural: string;
          Singular: string;
        }[];
        SelectedTerminology: {
          IsCampaignSpecific: boolean;
          ID: number;
          Plural: string;
          Singular: string;
          Verb: string;
          Article: 'A' | 'An';
        };
      };
      ProjectTerminologyModel: {
        DefaultTerminologies: {
          ID: number;
          Plural: string;
          Singular: string;
        }[];
        SelectedTerminology: {
          IsCampaignSpecific: boolean;
          ID: number;
          Plural: string;
          Singular: string;
          Article: 'A' | 'An';
        };
      };
    };
    RunningOrganizationCommonName: string;
    PermanentUrl: string;
    SectionName: DonationPageTabsEnum;
  };
  CurrencyTypeID: number;
  currencyType?: string; // formatted currencyType based on CurrencyTypeID
};

export type DonationPageFirstFormResponseType = BaseApiResponseType<
  GlobalResponseType & {
    CurrentSection: {
      CauseTerminology: {
        DefaultTerminologies: {
          ID: number;
          Plural: string;
          Singular: string;
        }[];
        SelectedTerminology: {
          IsCampaignSpecific: boolean;
          ID: number;
          Plural: string;
          Singular: string;
          Article: 'A' | 'An';
        };
      };
      DonationPageDisplayingConfigurationModel: {
        IsBannerEnabled: boolean;
        IsFundImageEnabled: boolean;
        IsPresetDonationDescriptionEnabled: boolean;
        IsPresetDonationImageEnabled: boolean;
        IsPresetDonationTitleEnabled: boolean;
      };
      Permissions: {
        CanAddImage: boolean;
        CanEditDonationLimits: boolean;
        CanEditCampaignPricing: boolean;
        CanEditChargingSettings: boolean;
        CanEditCheckInfo: boolean;
        CanEditCommonSettings: boolean;
        CanEditCurrencies: boolean;
        CanEditCutOffDate: boolean;
        CanEditDesiredStartDate: boolean;
        CanEditPaymentTypes: boolean;
        CanEditPresetContributionAmounts: boolean;
        CanEditPresets: boolean;
      };
      ShortDescription: string;
      ShowCampaignHeadline: boolean;
      IsStartCampaignAutomatically: boolean;
      DesiredStartDate: string | null;
      DesiredStartTime: string | null;
      // ContributionButtonTerminology: {
      //   DefaultTerminologies: {
      //     ID: number;
      //     Text: string;
      //     IsDefault: boolean;
      //     FundraisingActivityTypeID: number | null;
      //   }[];
      //   SelectedTerminology: {
      //     FundraisingActivityTypeID: number | null;
      //     ID: number;
      //     IsDefault: boolean;
      //     Text: string;
      //   };
      // };
      ContributionAmountPresets: DonationSetupPresetAmountListResponseType['Items'] | null;
      IsContributionPresetsSortDesc: boolean;
      // PaymentMethods: {
      //   IsEnabled: boolean;
      //   IsHidden: boolean;
      //   IsSelected: boolean;
      //   Name: string;
      //   Sequence: number;
      //   SupportRecurringPayments: boolean;
      //   Value: number;
      // }[];
      UseContributionAmountPresets: boolean;
      UseCauses: boolean;
      Medias: {
        ImagesRestrictions: {
          ImageHeight: number;
          ImageWidth: number;
        };
        Items: {
          ID: number;
          ImageUri: string;
          IsEmpty: boolean;
          MediaType: number;
        }[];
      };
      Currencies: { ID: number; Name: string; Symbol: string; IsApplePayAndGooglePayAvailable: boolean }[];
      IsAddressRequired: boolean;
      IsPhoneNumberRequired: boolean;
      // Countries: {
      //   Disabled: boolean;
      //   Group: unknown;
      //   Selected: boolean;
      //   Text: string;
      //   Value: string;
      // }[];
      // Check: {
      //   CheckAddressLine1: string | null;
      //   CheckAddressLine2: string | null;
      //   CheckAddressLine3: string | null;
      //   CheckAttentionTo: string | null;
      //   CheckCity: string | null;
      //   CheckCityID: unknown | null;
      //   CheckName: string | null;
      //   CheckPayableTo: string | null;
      //   CheckZipCode: string | null;
      //   CountryID: string;
      //   RegionID: number | null;
      // };
      // UsRegions: {
      //   Abbreviation: string;
      //   Country: string;
      //   CountryID: unknown;
      //   DisplayName: string;
      //   ID: number;
      //   Name: string;
      // }[];
      // CanadaRegions: {
      //   Abbreviation: string;
      //   Country: string;
      //   CountryID: null;
      //   DisplayName: string;
      //   ID: number;
      //   Name: string;
      // }[];
      EmailSubject: string | null;
      EmailTemplate: string;
      // TextToGiveViewModel: {
      //   CanEditTextToGiveKeyword: boolean;
      //   ContributionButtonTerminology: string;
      //   IsSupported: boolean;
      //   IsTextToGiveEnabled: boolean;
      //   IsTextToGiveKeywordValid: boolean;
      //   PermanentUrl: string;
      //   TextToGiveKeyword: null | string;
      // };
      FriendlyUrl: string | null;
      CurrencyTypeID: number;
      // DefaultPricingViewModel: {
      //   ShowPromoCodeFeeChargingTypeCode: boolean;
      //   PromoCodeFeeChargingTypeCode: number;
      //   ShowDefaultPricingCard: boolean;
      //   IsTipPricingAvailable: boolean;
      //   ServiceFeePercent: number;
      //   ServiceFeeRate: number;
      //   PricingTypeCode: number;
      //   DefaultPricingServiceFeeChargingTypeID: number;
      //   IsConvenienceFeeEnabled: boolean;
      //   ConvenienceFeeAmount: number;
      //   PaymentProcessorTypeCodes: number[];
      // };
    };
  }
>;

export type DonationPageSecondFormResponseType = BaseApiResponseType<
  GlobalResponseType & {
    CurrentSection: {
      Currencies: { ID: number; Name: string; Symbol: string; IsApplePayAndGooglePayAvailable: boolean }[];
      Permissions: {
        CanAddImage: boolean;
        CanEditDonationLimits: boolean;
        CanEditCampaignPricing: boolean;
        CanEditChargingSettings: boolean;
        CanEditCheckInfo: boolean;
        CanEditCommonSettings: boolean;
        CanEditCurrencies: boolean;
        CanEditCutOffDate: boolean;
        CanEditDesiredStartDate: boolean;
        CanEditPaymentTypes: boolean;
        CanEditPresetContributionAmounts: boolean;
        CanEditPresets: boolean;
      };
      PaymentMethods: {
        IsEnabled: boolean;
        IsHidden: boolean;
        IsSelected: boolean;
        Name: string;
        Sequence: number;
        SupportRecurringPayments: boolean;
        Value: number;
      }[];
      IsAddressRequired: boolean;
      IsPhoneNumberRequired: boolean;
      Countries: {
        Disabled: boolean;
        Group: unknown;
        Selected: boolean;
        Text: string;
        Value: string;
      }[];
      Check: {
        CheckAddressLine1: string | null;
        CheckAddressLine2: string | null;
        CheckAddressLine3: string | null;
        CheckAttentionTo: string | null;
        CheckCity: string | null;
        CheckCityID: unknown | null;
        CheckName: string | null;
        CheckPayableTo: string | null;
        CheckZipCode: string | null;
        CountryID: string;
        RegionID: number | null;
      };
      UsRegions: {
        Abbreviation: string;
        Country: string;
        CountryID: unknown;
        DisplayName: string;
        ID: number;
        Name: string;
      }[];
      CanadaRegions: {
        Abbreviation: string;
        Country: string;
        CountryID: null;
        DisplayName: string;
        ID: number;
        Name: string;
      }[];
      EmailSubject: string | null;
      EmailTemplate: string;
      TextToGiveViewModel: {
        CanEditTextToGiveKeyword: boolean;
        ContributionButtonTerminology: string;
        IsSupported: boolean;
        IsTextToGiveEnabled: boolean;
        IsTextToGiveKeywordValid: boolean;
        PermanentUrl: string;
        TextToGiveKeyword: null | string;
        IsInternationalTextToGiveEnabled: boolean;
      };
      AreFixedContributionsAllowed: boolean;
      AllowDonationDedication: boolean;
      UseCustomMinMaxContributionAmount: boolean;
      MinimumContributionAmount: number | null;
      MaximumContributionAmount: number | null;
      CustomFields: {
        BasicFields: [];
        CustomFields: {
          ID: number;
          IsRequired: boolean;
          Collect: boolean;
          Sequence: number;
          Readonly: boolean;
          CustomFieldTypeID: number;
          IsCustom: boolean;
          Name: string;
          HasOtherOption: boolean;
          Options: {
            ID: number;
            Name: string;
            Sequence: number;
          }[];
          HasNonEmptyValues: boolean;
        }[];
        Types: {
          Code: number;
          Name: string;
        }[];
      };
      EnableMarketingEmailsOption: boolean;
      EnableMarketingEmailsOptionLabel: string | null;
      IsProPricingEnabled: boolean;
      DefaultPricingViewModel: {
        IsVisible: boolean;
        ShowDefaultPricingCard: boolean;
        PricingTypeCode: number;
        DefaultPricingServiceFeeChargingTypeID: number;
        DefaultPricingProcessingFeeChargingTypeID: number;
        IsConvenienceFeeEnabled: boolean;
        ConvenienceFeeAmount: number;
        ConvenienceFeeAmountType: 1 | 2 | null;
        CanChargeProcessingFeeToSupporter: boolean;
        ProcessingFeesChargedToSupporter: boolean;
        ShowPromoCodeFeeChargingTypeCode: boolean;
        PromoCodeFeeChargingTypeCode: number;
        MaxPerItemFee: number | null;
        AuctionItemTerminologySingular: string | null;
        IsTipPricingAvailable: boolean;
        ServiceFeeRate: number;
        PartnerFundraisingActivityTypeServiceFeeRateID: number;
        ServiceFeePercent: number;
        PaymentProcessorTypeCodes: number[];
        ServiceFeeChangedGroupName: string;
      };
      PlusSubscriptionPricingViewModel: {
        IsVisible: boolean;
        ShowPlusSubscriptionPricingCard: boolean;
        PricingPlanName: string | null;
        CanChargeProcessingFeeToSupporter: boolean;
        ProcessingFeesChargedToSupporter: boolean;
        ShowFeePercent: boolean;
        ServiceFeeChangedGroupName: string | null;
        ServiceFeePercent: number;
        ServiceFeeRate: number;
        DefaultPricingServiceFeeChargingTypeID: number;
        DefaultPricingProcessingFeeChargingTypeID: number;
        IsConvenienceFeeEnabled: boolean;
        ConvenienceFeeAmount: number;
        ConvenienceFeeAmountType: 1 | 2 | null;
        PaymentProcessorTypeCodes: number[];
      };
      IsInTestMode: boolean;
    };
  }
>;

export type DonationPageThirdFormResponseType = BaseApiResponseType<
  GlobalResponseType & {
    CurrentSection: {
      EnableAnonymousDonation: boolean;
      EnableHideEmail: boolean;
      // Permissions: {
      //   CanAllowDonationsDirectlyToOrganization: boolean;
      //   CanChooseParentCampaign: boolean;
      //   CanEditAdministrators: boolean;
      //   CanEditAnonymityOfContributions: boolean;
      //   CanEditChargingSettings: boolean;
      //   CanEditCheckInfo: boolean;
      //   CanEditCloseOnGoal: boolean;
      //   CanEditCommonSettings: boolean;
      //   CanEditContributionsDuration: boolean;
      //   CanEditCustomFields: boolean;
      //   CanEditCutOffDate: boolean;
      //   CanEditDedicationOfContributions: boolean;
      //   CanEditDonationLimits: boolean;
      //   CanEditOrganizerPromoCode: boolean;
      //   CanEditPaymentTypes: boolean;
      //   CanEditPresetContributionAmounts: boolean;
      //   CanEditPresets: boolean;
      //   CanEditRegistrationNotice: boolean;
      //   CanEditTeamMemberRegistrationEndDate: boolean;
      //   CanEditTeamMemberResistartionStartDate: boolean;
      //   CanEnableAttributes: boolean;
      //   CanTurnOnSpecialInstructions: boolean;
      // };
      FundCode: string | null;
      HaveFundCode: boolean;
      UkGiftAidShown: boolean;
      IsUkGiftAidEnabled: boolean;
      GiftAidStatement: string;
      GiftAidAgreement: string;
      PricingViewModel: {
        ShowOrganizerPromoCode: boolean;
        HaveOrganizerPromoCode: boolean;
        OrganizerPromoCode: string | null;
        OrganizerPromoCodeString: string | null;
      };
      IsVisibleIntegrationSection: boolean;
      IntegrationsOptionsSubsectionViewModel: {
        OrganizationId: number;
        BloomerangFields: {
          IsVisible: boolean;
          CampaignFieldValues: TrayIoBloomerangFieldValue[];
          CampaignFieldValueID: number | null;
          FundFieldValues: TrayIoBloomerangFieldValue[];
          FundFieldValueID: number | null;
          AppealFieldValues: TrayIoBloomerangFieldValue[];
          AppealFieldValueID: number | null;
          BloomerangFieldsUpdatedGroupName: string;
        };
        LittleGreenLightFields: {
          IsVisible: boolean;
          CampaignFieldValues: TrayIoLittleGreenLightFieldValue[];
          CampaignFieldValueID: number | null;
          FundFieldValues: TrayIoLittleGreenLightFieldValue[];
          FundFieldValueID: number | null;
          AppealFieldValues: TrayIoLittleGreenLightFieldValue[];
          AppealFieldValueID: number | null;
          EventFieldValues: TrayIoLittleGreenLightFieldValue[];
          EventFieldValueID: number | null;
          LittleGreenLightFieldsUpdatedGroupName: string;
        };
      } | null;
      ContributionBankStatement: string | null;
      CanHaveAdditionalAmount: boolean;
      ShowAdditionalAmount: boolean;
      IsPledge: boolean;
      AreFixedContributionsAllowed: boolean;
      AreFixedContributionsAllowedVisible: boolean;
      IsDonationWithoutItemsHeadlineAndButtonVisible: boolean;
      DonationWithoutItemsHeadLineText: string | null;
      DonateWithoutItemsButtonText: string | null;
      ShowAreCompleteAnonymousContributions: boolean;
      AreCompleteAnonymousContributionsDisabled: boolean;
      AllowDonationDedication: boolean;
      ShowSpecialInstructions: boolean;
      IsSpecialInstructionsVisible: boolean;
      UseCustomMinMaxContributionAmount: boolean;
      MinimumContributionAmount: number | null;
      MaximumContributionAmount: number | null;
      EnableMarketingEmailsOption: boolean;
      EnableMarketingEmailsOptionLabel: string | null;
      Notice: string | null;
      IsSupporterNoticeAcknowledgmentRequired: boolean;
      ContributionNotificationRecipients: { Email: string }[] | null;
      ContactOrganizerEmailRecipients: { Email: string }[] | null;
      AreNotificationsAboutNewDonorsAndDonationsEnabled: boolean;
      TimezoneID: number;
      Timezones: {
        ID: number;
        Name: string;
      }[];
      AllowRecurringDonations: boolean;
      HasRecurringContributions: boolean;
      DefaultRecurrencePeriodID: number;
      AllowDonorsChooseRecurringDonationFrequency: boolean;
      IsRecurringDonationUpsellEnabled: boolean;
      UpsellPercentage: number;
      UpsellTitle: string | null;
      UpsellDescription: string | null;
    };
  }
>;
